import React, {useState, useContext, useReducer, useEffect} from 'react';
import axios from 'axios';
import uuid from 'react-uuid';
import moment from "moment";
import {Link, useParams, useHistory} from 'react-router-dom';
import {Alert, Button, Card, Col, Form, Row} from 'react-bootstrap';
import {useLocalStorage} from 'react-use';
import AuditContext from '../Utils/context.js';
import {ACTIONS} from '../Utils/action.js';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import AuditorMinutes from '../Modal/Minutes/Auditor.js';
import EventContext from './Visitation/context';
import EventReducer from './Visitation/reducer';
import EventModalReducer from './components/Event/reducer';
import {ACTIONS as EVENT_ACTION} from './components/Event/action';

import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import { set } from 'date-fns';
// react component used to create alerts
import Event from './components/Event.js';


const defaultPopupValue = {
  uuid: uuid(),
  title: ``,
  start: moment(),
  end: moment(),
  reminders: []
}

export default function Visitation()
{
  const history = useHistory()
  const {schedule, dispatchSchedule} = useContext(AuditContext);

  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert(null);
  const [showMinutes, setShowMinutes] = useState(false);


  // This is for tag calender
  const {employeeId, scheduleId} = useParams();
  const localizer = momentLocalizer(moment);
  const [events, dispatchEvents] = useReducer(EventReducer, []);
  const [popup, dispatchPopup] = useReducer(EventModalReducer, defaultPopupValue);
  const [timeMin, setTimeMin] = useState(moment().startOf('month').toISOString());
  const [timeMax, setTimeMax] = useState(moment().endOf('month').toISOString());
  const [showCalender, setShowCalender] = useState(false);
  const [showEvent, setShowEvent] = useState(false);

  const canUpdate = () => {
    // except VISITATED (Visitation is on progress)
    if (!['VISITED', 'APPROVED', 'COMPLETED'].includes(schedule.SCHEDULE_STATUS)) {
        return <Alert variant="info" style={{textAlign: 'center'}}>Visitation is on progress.</Alert>;
    }

    // except APPROVED (Waiting admin for approval)
    if (!['EVALUATED', 'APPROVED', 'COMPLETED'].includes(schedule.SCHEDULE_STATUS)) {
      return <Button variant="success" onClick={handleApproveMinutes}>Approve</Button>;
    }

    // except COMPLETED (done)
    if (!['EVALUATED', `VISITED`, 'COMPLETED'].includes(schedule.SCHEDULE_STATUS)) {
      return <Alert variant="info" style={{textAlign: 'center'}}>Visitation Process has been completed.</Alert>;
    }
  }

  const handleSendEmail = async () => {
    try {
      let formData = new FormData();
      formData.append('TYPE', 'CREATE_FINDING');
      formData.append('EMAIL', JSON.parse(localStorage.getItem('authenticated')).employee.EMP_EMAIL);
      formData.append('SCHEDULE', schedule.SCHEDULE_ID);
      const response = await axios.post(`${process.env.REACT_APP_API_HOST}notification/send-email`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        }
      });
    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleApproveMinutes = () => {
    handleSendEmail()
    setShowMinutes(<MinutesModal onHide={handleHideMinutes} onSubmit={handleSubmitMinutes} schedule={schedule}/>);
  }



  const handleSubmitMinutes = (statement, id) => {

    try {

      const onSuccessCallback = async () => {

        const response = await axios.put(
          `${process.env.REACT_APP_API_HOST}minutes/${id}`,
          {
            BPMI_NOTE: statement,
            APPROVED_AT: moment().format('YYYY-MM-DD hh:mm:ss'),
            APPROVED_BY: auth.employee.EMP_ID,
          },
          {
            params: {expand: 'schedule'},
            headers: {Authorization: `Bearer ${auth.token}`}
          }
        );

        const responseSchedule = await axios.put(
          `${process.env.REACT_APP_API_HOST}schedules/${schedule.SCHEDULE_ID}`,
          {SCHEDULE_STATUS: 'APPROVED'},
          {headers: {Authorization: `Bearer ${auth.token}`}}
        )

        dispatchSchedule({
          type: ACTIONS.EDIT,
          payload: {SCHEDULE_STATUS: responseSchedule.data.SCHEDULE_STATUS},
        });

        handleHideMinutes();
        history.push(`/admin/audits/${schedule.SCHEDULE_ID}/findings`);
      }

      const confirmDialog = confirm("Are you sure?");
      if (confirmDialog) {
        onSuccessCallback();
      }

    } catch (error) {
      alert(error);
      console.log(error);
    }

  }

  const getVariant = (form) => {

    switch (true) {
      case (form?.VISIT_AT !== null && form?.VISIT_BY !== null):
        return 'success';
      case (form?.EVALUATE_AT !== null && form?.EVALUATE_BY !== null):
        return 'primary';
      default:
        return 'secondary';
    }
  }

  const handleHideMinutes = () => {
    setShowMinutes(null);
  }

  const handleTagCalender = () => {
    setShowCalender(true)
  }

  const fetchEvents = async () => {

    let response = await axios.get(
      `${process.env.REACT_APP_API_HOST}calendars`,
      {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: {
          email: `siami@umn.ac.id`,
          timeMin,
          timeMax,
        }
      }
    );

    dispatchEvents({
      type: ACTIONS.FETCH,
      payload: response.data,
    });

  }

  const handleRemoveEvent = async (id) => {
    try{

      const response = await axios.delete(
        `${process.env.REACT_APP_API_HOST}schedule-visits/${id}`,
          { headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
      );

      if (response.status === 200){
        fetchEvents();
        handleHideEvent();
      }else{
        console.log(response);
      }

    }catch(ex){
      console.log(ex);
      window.alert(ex.toString());
    }

  }

  const handleSubmitEvent = async (
    title,
    notificationType,
    dateValue,
    dateEnd,
    timeStart,
    timeEnd,
    isAllDay,
    notificationValue,
    reminderType,
    id,
    googleCalendarId
  ) => {

    let notificationMinutes = 1;
    // reminder
    switch (true) {
      case notificationType === 'hours' :
        notificationMinutes = 60;
        break;
      case notificationType === 'days' :
        notificationMinutes = 24 * 60;
        break;
    }

    // date time
    let startPeriod = '';
    let endPeriod = '';

    switch (true) {
      case isAllDay :
        startPeriod = moment(dateValue).format('YYYY-MM-DD') + 'T00:00:00-07:00';
        endPeriod = moment(dateEnd).format('YYYY-MM-DD') + 'T00:00:00-07:00';
        break;

      case !isAllDay :
        startPeriod = moment(dateValue).format('YYYY-MM-DD') + 'T' + timeStart + ':00-07:00';
        endPeriod = moment(dateEnd).format('YYYY-MM-DD') + 'T' + timeEnd + ':00-07:00';
        break;
    }


    try {
      let payload = {
        'VISIT_ID': id,
        "SCHEDULE_ID" : schedule.SCHEDULE_ID,
        "TITLE" : title,
        "START_DATE": dateValue,
        "TIME_START": timeStart,
        "TIME_END": timeEnd,
        "END_DATE": dateEnd,
        "ALL_DAY": isAllDay ? 1 : 0,
        'REMINDER_TYPE': reminderType,
        'NOTIFICATION_TYPE': notificationType,
        'NOTIFICATION_VALUE': notificationValue,
        GOOGLE_CALENDAR_ID: googleCalendarId,
        CREATED_AT: moment().format('YYYY-MM-DD hh:mm:ss'),
        CREATED_BY: auth.employee.EMP_ID,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}schedule-visits`, payload,
        {
          headers: {Authorization: `Bearer ${auth.token}`},
        }
      );

      if (response.status == 201 || response.status == 200) {
        handleHideEvent();
        fetchEvents();
      }else{
        window.alert('Uupps, something error during insert event to database');
      }

    } catch (error) {
      console.log(error);
      window.alert(error);
    }
  }

  const handleSelectEvent = ({id}) => {


    const event = events.find(event => event.id === id);

    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: event
    });

    setShowEvent(
      <Event
        event={event}
        scheduleId={scheduleId}
        onHide={handleHideEvent}
        onSubmit={handleSubmitEvent}
        onRemove={handleRemoveEvent}
      />
    );
  };

  const handleSelectSlot = ({start, end}) => {

    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: {
        start: moment(start),
        end: moment(end),
      }
    });

    setShowEvent(<Event
      scheduleId={scheduleId}
      onHide={handleHideEvent}
      onSubmit={handleSubmitEvent}
    />);
  };

  const handleRangeChange = e => {
    setTimeMin(moment(e.start).toISOString());
    setTimeMax(moment(e.end).toISOString())
  }

  const handleHideEvent = () => {
    setShowEvent(null);
    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: defaultPopupValue
    });
  }

  const eventColors = (event, start, end, isSelected) => {
    var backgroundColor = "rbc-event-";
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "default");
    return {
      className: backgroundColor,
    };
  };

  useEffect(() => {
    fetchEvents();
  }, [timeMin, timeMax]);


  return (
    <EventContext.Provider value={{
      events, dispatchEvents,
      popup, dispatchPopup
    }}>
      {swal}{showMinutes}{showEvent}
      <h3>Visitation</h3>
      {!showCalender ? <a><Button onClick={handleTagCalender} >Tag Your Calendar</Button><hr /></a> : ''}
      {showCalender ? <Button onClick={fetchEvents} variant="success">Refresh Calendar</Button> :''}
      {showCalender ?
        <Row>
          <Col md="12">
            <Card>
              <Card.Body>
                <BigCalendar
                  selectable={true}
                  localizer={localizer}
                  events={events}
                  defaultView="month"
                  scrollToTime={new Date(1970, 1, 1, 6)}
                  defaultDate={new Date()}
                  onRangeChange={handleRangeChange}
                  onSelectEvent={handleSelectEvent}
                  onSelectSlot={(slotInfo) => handleSelectSlot(slotInfo)}
                  eventPropGetter={eventColors}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      : ''}
      <Form.Group>
        {schedule.forms && schedule.forms.map((form, key) => (
          <Link key={key} to={`/admin/visitations/${form.FORM_ID}`}>
            <Button variant={getVariant(form)}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
          </Link>
        ))}
      </Form.Group>
      <Form.Group>
        {canUpdate()}
      </Form.Group>
    </EventContext.Provider>
  )
}